module.exports = __webpack_public_path__ + "static/media/DeviceExtra.2e7a7a19.png";